import { Flex } from "@chakra-ui/react";
import { ReactNode } from "react";
import type { AppliedFilter } from "components/Shared/FilterEditor/utils";
import RetailerTypeCheckboxes, {
  getValueFromFilters as getRetailerTypeValueFromFilters,
  makeFiltersHandleChange as makeFiltersHandleRetailerTypeChange,
} from "components/Shared/RetailerDirectory/RetailerTypeCheckboxes";
import ArchivedStatusButtonGroup, {
  getValueFromFilters as getArchivedStatusValueFromFilters,
  makeFiltersHandleChange as makeFiltersHandleArchivedStatusChange,
} from "components/Shared/ArchivedStatusButtonGroup";
import IncludeCustomFilter, {
  getValueFromFilters as getIncludeCustomValueFromFilters,
  makeFiltersHandleChange as makeFiltersHandleIncludeCustomChange,
} from "components/Shared/IncludeCustomFilter";

export type HiddenFilters = {
  archived?: boolean;
  retailerType?: boolean;
  includeCustom?: boolean;
};

type Props = {
  children?: ReactNode;
  filters: AppliedFilter[];
  hiddenFilters?: HiddenFilters;
  includeCheckboxes?: ReactNode;
  isReady?: boolean;
  onFiltersChange: (filters: AppliedFilter[]) => void;
  retailerFilterPrefix?: string;
};

export default function FilterBarControls({
  children,
  filters,
  hiddenFilters,
  includeCheckboxes,
  isReady = true,
  onFiltersChange,
  retailerFilterPrefix,
}: Props) {
  return (
    <Flex gap={4}>
      {!hiddenFilters?.archived && (
        <ArchivedStatusButtonGroup
          value={getArchivedStatusValueFromFilters(filters)}
          onChange={makeFiltersHandleArchivedStatusChange(
            filters,
            onFiltersChange,
          )}
          alignSelf="center"
        />
      )}

      {!hiddenFilters?.retailerType && (
        <RetailerTypeCheckboxes
          size="sm"
          value={getRetailerTypeValueFromFilters(filters, retailerFilterPrefix)}
          onChange={makeFiltersHandleRetailerTypeChange(
            filters,
            onFiltersChange,
            retailerFilterPrefix,
          )}
          listProps={{ lineHeight: "1" }}
        />
      )}

      {(!hiddenFilters?.includeCustom || includeCheckboxes) && (
        <Flex direction="column" gap={2} justifyContent="center">
          <IncludeCustomFilter
            isChecked={
              isReady &&
              getIncludeCustomValueFromFilters(filters, retailerFilterPrefix)
            }
            onChange={makeFiltersHandleIncludeCustomChange(
              filters,
              onFiltersChange,
              retailerFilterPrefix,
            )}
          />
          {includeCheckboxes}
        </Flex>
      )}

      {children}
    </Flex>
  );
}
